export default {
	badge: 'Docs received',
	cards: {
		drivingLicence: 'Driving licence',
		proofOfAddress: 'Proof of address',
		v5c: 'V5C logbook',
	},
	text: 'This seller has uploaded their docs early. These sellers are 22% more likely to complete the sale and transact 12% faster.',
};
